import * as React from "react";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export function DreamsMaxIcon({ shouldDisplay }: { shouldDisplay: boolean }) {
    if (!shouldDisplay) {
        return null;
    }

    const styleClass = StyleClass(`dreamsMaxIconBadge`, {
        background: "hsl(122deg 61% 37%)",
        padding: "2px 6px",
        borderRadius: "5px",
        color: "white",
        fontSize: "13px",
        marginRight: "10px",
        opacity: 0.7,
    });

    return <span className={styleClass}>MAX</span>;
}
